export default __webpack_public_path__ + "static/media/tapan.8b7eb4d2.png";